// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hyxZEG6w7YMrM_ {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px;
  padding: 8px 0;
  color: var(--dynamic-text);
  font-weight: 500;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `hyxZEG6w7YMrM_`
};
export default ___CSS_LOADER_EXPORT___;
